import { render, staticRenderFns } from "./ChartsView.vue?vue&type=template&id=7bff60c4&"
import script from "./ChartsView.vue?vue&type=script&lang=js&"
export * from "./ChartsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports